<template>
    <div class="app-body flex-auto bg-gray-100 p-6" :class="{
        'pt-24': ! collapsed && ! tiny && ! short,
        'pt-20': ! collapsed && ! tiny && short,
        'theme-aurora': $root.theme === 'aurora',
        'theme-phoenix': $root.theme === 'phoenix'
    }">
        <div class="max-w-none m-auto h-full" :class="`md:${mediumMaxWidth}`">
            <div class="flex flex-col h-full">
                <slot>
                    <div class="flex flex-col md:flex-row">
                        <div class="w-full" :class="{ 'md:w-1/2': $slots['bottom'] }">
                            <h4 v-if="$slots['title']" class="app-body-title title">
                                <slot name="title" />
                            </h4>
                            <p v-if="$slots['text']" class="app-body-text text leading-relaxed">
                                <slot name="text" />
                            </p>

                            <div v-if="$slots['main']" class="app-body-main">
                                <slot name="main" />
                            </div>
                        </div>
                        <div v-if="$slots['bottom']" class="w-full" :class="{ 'md:w-1/2 md:ml-12': $slots['bottom'] }">
                            <slot name="bottom" />
                        </div>
                    </div>

                    <div v-if="footer || $slots['footer']" class="app-body-footer flex-1 flex items-end justify-center pt-6">
                        <slot v-if="$slots['footer']" name="footer" />
                        <div v-else class="flex-1 flex-col items-end justify-center text-black pt-6 text-center">
                            <div class="mb-2 flex justify-around flex-wrap max-w-lg mx-auto text-center">
                                <a v-if="$root.isImpersonating" href="/stop-impersonating" class="px-3 py-1 text-black no-underline font-semibold">Stop</a>
                                <a v-else-if="$root.viewNova" href="/nova" class="px-3 py-1 text-black no-underline font-semibold">Admin</a>
                                <a :href="$root.app.terms_of_use_url" target="_blank" class="px-3 py-1 text-black no-underline font-semibold">Terms of Use</a>
                                <a :href="$root.app.privacy_policy_url" target="_blank" class="px-3 py-1 text-black no-underline font-semibold">Privacy Policy</a>
                                <a :href="$root.app.contact_us_url" target="_blank" class="px-3 py-1 text-black no-underline font-semibold">Need Help?</a>
                            </div>

                            <p data-testid="copyright" class="leading-normal">© {{ currentYear() }} {{ $root.app.company_name }}. All&nbsp;rights&nbsp;reserved.</p>
                        </div>
                    </div>
                </slot>

                <app-menu :open="$parent.menuOpen" @close="closeMenu" />
            </div>
        </div>
    </div>
</template>

<script>
    import AppMenu from './AppMenu';
    import Moment from 'moment';

    export default {
        props: {
            collapsed: {
                type: Boolean,
                default: false
            },
            tiny: {
                type: Boolean,
                default: false
            },
            short: {
                type: Boolean,
                default: false
            },
            footer: {
                type: Boolean,
                default: false
            },
            mediumMaxWidth: {
                type: String,
                default: 'max-w-800'
            }
        },

        components: {
            AppMenu
        },

        methods: {
            currentYear() {
                return Moment().year();
            }
        },

        inject: ['closeMenu']
    }
</script>